var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentType,_vm._g(_vm._b({tag:"component",staticClass:"group btn"},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('ui-icon',{staticClass:"text-xl transition-transform",attrs:{"icon":"arrow"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }